<template>
	<div id="mArticle" v-cloak>
		<div v-if="totalBookmarks" class="my-bookmark">
			<h3 class="sr_only">북마크</h3>
			<bookmark-count :tags="tags" :focused-tag="focusedTag" :total="totalBookmarks"></bookmark-count>
			<div v-if="tags.length > 1" class="my-bookmark__tag-area">
				<a href="javascript:" class="my-bookmark__tag-area__toggle #tag_folder" @click="toggleTagList">#태그<span :class="[isTagListOpen ? 'ico-open' : 'ico-fold']"><span class="sr_only">목록 열기 / 닫기</span></span></a>
				<div :class="['my-bookmark__scroll-tag', isTagListOpen ? 'my-bookmark__scroll-tag--open' : '']">
					<div class="my-bookmark__scroll-tag__inner" :style="style.innerScroll">
						<div class="my-bookmark__slide" :style="style.slide" v-hammer:pan="onPan">
							<tag-list v-for="i in tagPageIndices" @tag-select="onTagSelect" :tag-list="tags | filterByPage(i, tagsPerPage)" :focused="focusedTag" :page="i" :max-page="maxTagPage"></tag-list>
						</div>
					</div>
					<div class="my-bookmark__tag-guide">
						<p class="my-bookmark__tag-guide__description"><a href="javascript:" @click="goToApp()" class="my-bookmark__tag-guide__link #w2a_bookmark">카페앱</a>에서 태그를 추가&amp;편집하여<br>나만의 북마크 목록을 만들어보세요.</p>
						<span class="my-bookmark__tag-guide__paging"><em class="my-bookmark__tag-guide__paging__current-page">{{tagPage+1}}</em>/{{maxTagPage}}</span>
					</div>
				</div>
			</div>
			<div v-else class="empty-tag-info">
				<p class="empty-tag-info__description">카페앱에서 태그를 추가&amp;편집하여<br>나만의 북마크 목록을 만들어 보세요.</p>
				<a href="javascript:" class="empty-tag-info__to-cafe-app #w2a_bookmark" @click="goToApp()">
					<span class="ico-cafe-emblem"></span>카페앱으로 보기
				</a>
			</div>
			<bookmark-list @delete="onBookmarkDelete" :bookmark="bookmark" :post-list="currentBookmarks"></bookmark-list>
			<pagination :page="bookmarkPage" :max-page="maxBookmarkPage" @page-select="onPageSelect"></pagination>
		</div>
		<div v-else class="my-bookmark">
			<h3 class="sr_only">북마크</h3>
			<div class="bookmark-info">
				<img src="//t1.daumcdn.net/cafe_image/mobile/m640/bookmark-info_240322.png" width="161" height="121" alt="북마크 하는 방법">
				<strong class="bookmark-info__title bookmark-info__title--underline">
					북마크한 글이 없습니다.
				</strong>
				<p class="bookmark-info__description">게시글 하단 더보기 버튼을 누르고<br>마음에 드는 글을 북마크 해보세요.</p>
			</div>
		</div>
		<div class="cafe-make">
			<strong class="cafe-make__title">관심있는 주제의 카페를<br> 직접 개설하고 운영해 보세요!</strong>
			<a href="/_makeCafe" :click="makeCafe" class="cafe-make__link #create_cafe">
				<span class="cafe-make__icon"></span>카페 만들기
			</a>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import { VueHammer } from 'vue2-hammer';

	import BookmarkApi from './bookmark';

	import BookmarkCount from './components/BookmarkCount.vue';
	import TagList from './components/TagList.vue';
	import BookmarkList from './components/BookmarkList.vue';
	import Pagination from './components/Pagination.vue';

	Vue.use(VueHammer);

	export default {
		components: {
			BookmarkCount, TagList, BookmarkList, Pagination
		},

		data() {
			return {
				bookmark: new BookmarkApi(),
				focusedTag: '',

				bookmarkPage: 0,
				tagPage: 0,

				tagsPerPage: 10,
				bookmarksPerPage: 20,

				tags: [
					{id: '', tagString: '전체', taggingCount: -1}
				],

				bookmarkedPosts: [],

				isTagListOpen: true,

				isMoving: false,
				percentage: 0
			};
		},

		computed: {
			style: function () {
				const tagUnitHeight = 41;

				return {
					innerScroll: {
						height: `${tagUnitHeight * Math.ceil(this.currentTagList.length / 2) + 6}px`
					},
					slide: {
						width: `${this.maxTagPage * 100}%`,
						transform: this.isMoving
							? `translateX(${(this.percentage - this.tagPage * 100) / this.maxTagPage}%)`
							: `translateX(${-this.tagPage / this.maxTagPage * 100}%)`
					}
				};
			},

			maxBookmarkPage: function () {
				return Math.ceil(this.totalBookmarks / this.bookmarksPerPage);
			},
			maxTagPage: function () {
				return Math.ceil(this.tags.length / this.tagsPerPage);
			},

			totalBookmarks: function () {
				const taggingCount = this.tags[0] ? this.tags[0].taggingCount : 0; 
				return Math.max(0, taggingCount);
			},

			tagPageIndices: function () {
				return [...Array(this.maxTagPage).keys()];
			},
			currentTagList: function () {
				return this.$options.filters.filterByPage(this.tags, this.tagPage, this.tagsPerPage);
			},

			currentBookmarks() {
				if (!this.focusedTag) {
					return this.bookmarkedPosts;
				}

				return this.bookmarkedPosts.filter((_, i) => this.bookmarkPage * this.bookmarksPerPage <= i && i < (this.bookmarkPage+1) * this.bookmarksPerPage);
			},
		},

		filters: {
			filterByPage: function (list, page, perPage) {
				return list.filter((_, i) => page*perPage <= i && i < (page+1)*perPage);
			}
		},

		methods: {
			toggleTagList: function () {
				this.isTagListOpen = !this.isTagListOpen;
			},

			onPageSelect: function(page) {
				this.bookmarkPage = page;
				this.loadPostList({ tagId: this.focusedTag, page: page });
			},

			onTagSelect: function (tagId) {
				this.focusedTag = tagId;
				this.bookmarkPage = 0;

				this.loadPostList({ tagId: this.focusedTag, page: 0 });
			},

			onBookmarkDelete: async function (permLink, tagIds) {
				this.bookmarkedPosts = this.bookmarkedPosts.filter(v => v.permLink !== permLink);

				this.tags.forEach((tag, i) => {
					if (i === 0 || tagIds.findIndex(v => v === tag.id)) {
						this.tags[i].taggingCount--;
					}
				});
				this.tags = this.tags.filter(tag => tag.taggingCount);

				if (this.focusedTag && this.tags.findIndex(v => v.id === this.focusedTag) < 0) {
					this.focusedTag = '';
					this.loadPostList();
				}
			},
			loadTagList: async function () {
				let tags;

				const data = await this.bookmark.loadTags();
				tags = data.tags;

				this.tags = this.tags.concat(tags);
			},
			loadPostList: async function ({tagId = '', page = 0} = {}) {
				let bookmarks, totalCount;

				const data = tagId
					? await this.bookmark.loadPostsByTagId(tagId)
					: await this.bookmark.loadPostsByPage(page, this.bookmarksPerPage);
				bookmarks = data.bookmarks;
				totalCount = data.totalCount;

				if (!tagId) {
					this.tags[0].taggingCount = totalCount;
				} else {
					this.tags.find(v => v.id === tagId).taggingCount = totalCount;
				}

				for (let i = 0; i < bookmarks.length; i++) {
					bookmarks[i].title = bookmarks[i].title.replace(/<\/?[^>]+(>|$)/g, '');
					bookmarks[i].permLink = bookmarks[i].permLink.replace(/https?:\/\/.*cafe(.dev)?.daum.net/, '');
				}
				this.bookmarkedPosts = bookmarks;
			},

			goToApp: function () {
				Utils.web2app('daumcafe://bookmarks');
			},

			onPan: function (event) {
				const threshold = 10;
				this.percentage = event.deltaX / window.innerWidth * 100;

				if (event.isFinal) {
					this.isMoving = false;
					if (this.percentage > threshold) {
						this.tagPage = Math.max(0, this.tagPage - 1);
					} else if (this.percentage < -threshold) {
						this.tagPage = Math.min(this.tagPage + 1, this.maxTagPage - 1);
					}
				} else {
					this.isMoving = true;
				}
			},

			makeCafe() {
				location.href = '/_makeCafe?r=' + document.URL;
				return false;
			}
		},

		created: async function () {
			this.loadPostList();
			this.loadTagList();
		},
	}
</script>
